// Copyright Epic Games, Inc. All Rights Reserved.

import React from "react";
import { ErrorPage } from "../components/common/error/ErrorPage";
import { UINotFoundErrorCode } from "../errors/UI.errorCodes";

export default function NotFoundPage(): JSX.Element {
  // TODO: Add localization for title here. EOS-15205
  return (
    <ErrorPage
      errorCode={UINotFoundErrorCode}
      onDismiss={() => window.close()}
    />
  );
}
